//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    name: "couponDestruction",
    data(){
        return{
            snapshotId: '',
            name: '',
            offerCode: '',
            icon: '',
        }
    },
    methods: {
        // 核销
        breakClick(){
          this.$http.postPut(`/dayDiscount/coupon/couponSnapshot/offlineVerification/${this.snapshotId}`).then(res => {
              if(res.data.code === 10000){
                  this.$toast({msg: this.$t('everyDaySpecial.couponDestruction.t3')})
                  this.$router.go(-1)
              }else{
                  this.$toast({msg: this.$t('everyDaySpecial.couponDestruction.t4')})
              }
          })
        },
    },
    created() {
        this.snapshotId = this.$route.query.snapshotId
        this.name = this.$route.query.couponName
        this.offerCode = this.$route.query.offerCode
        this.icon = this.$route.query.icon
    }
}



// WEBPACK FOOTER //
// ./src/page/everyDaySpecial/couponDestruction.vue